module.exports = __webpack_public_path__ + "static/media/spa-primary.a6d241b0.jpg";